<template>
  <div v-if="podeEditar" class="editar-publico">
    <a :href="url" target='_blank' title='Editar Conteúdo'><img src="../assets/images/icon-editar-exibir.svg" class="editar-pagina" /></a>
  </div>
</template>

<script>
// Rotas de edição do legisla_admin_vue (src/router/rotasPrivadas.js).
const CAMINHOS_EDICAO = {
  legislacao: "legislacoes",
  ato_infralegal: "atos-infralegais",
  mensagem_veto: "mensagens-veto",
};

export default {
  name: "BotaoEditar",
  props: {
    tipo: {
      type: String,
      required: true,
      validator: (valor) => Object.keys(CAMINHOS_EDICAO).includes(valor),
    },
    id: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      podeEditar: false,
    };
  },
  computed: {
    url() {
      return `${process.env.VUE_APP_ADMIN_URL}/${CAMINHOS_EDICAO[this.tipo]}/${this.id}/edit`;
    },
  },
  watch: {
    id: {
      immediate: true,
      handler: "verificarPermissao",
    },
  },
  methods: {
    // O público não tem login: quem decide é o admin, a partir do cookie de sessão
    // dele (credentials: "include"), com as mesmas regras de permissão do SGU usadas
    // no botão de editar do admin.
    async verificarPermissao() {
      this.podeEditar = false;
      if (!this.id) return;

      try {
        const resposta = await fetch(
          `${process.env.VUE_APP_ADMIN_API_URL}/api/v1/permissoes_edicao/${this.tipo}/${this.id}`,
          { credentials: "include" }
        );
        if (!resposta.ok) return;

        const dados = await resposta.json();
        this.podeEditar = !!dados.pode_editar;
      } catch (error) {
        // Admin fora do ar ou bloqueado por CORS: só não mostra o botão.
        this.podeEditar = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// Fica empilhado logo acima do botão de PDF (DownloadPdf.vue): bottom dele +
// 2.18rem de altura + 0.82rem de respiro, por isso os bottom andam juntos.
.editar-publico {
  position: fixed;
  z-index: 9;
  bottom: 16rem;
  right: 1.05rem;
  transition: 0.3s ease-in-out;

  @media (max-width: 767px) and (max-height: 959px) {
    bottom: 14rem;
  }
  @media (max-width: 639px) and (max-height: 959px) {
    bottom: 13rem;
  }

  a{
    background-color: white;
    box-shadow: 0rem 0rem 1rem #6b6b6b;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    border-radius: 50%;
    height: 2.18rem;
    width: 2.18rem;
    .editar-pagina{
      height: 1.2rem;
      max-width: none;
      padding: 0rem;
    }
  }
}

@media print {
    .editar-publico {
      display: none;
    }
}
</style>
